import { get as getFromStorage, set as setInStorage } from 'lib/storage/isomorphicLocalStorage'
import type { IntlShape } from 'react-intl'

export const LAST_USED_LOGIN_METHOD_KEY = 'accountAccess:lastUsedLoginMethod'

export const getLastUsedLoginMethodLabel = (intl: IntlShape): string => {
  return intl.formatMessage({
    id: 'cG1VAmlHmwFSuRGkAq0C',
    defaultMessage: 'Last used',
    description: 'Label shown for the previously used account login method',
  })
}

export const LAST_USED_LOGIN_METHODS = ['email', 'phone', 'otp', 'google', 'apple', 'facebook'] as const

export type LastUsedLoginMethod = typeof LAST_USED_LOGIN_METHODS[number]

export const isLastUsedLoginMethod = (value: unknown): value is LastUsedLoginMethod => {
  return typeof value === 'string' && LAST_USED_LOGIN_METHODS.includes(value as LastUsedLoginMethod)
}

export const getLastUsedLoginMethod = (): LastUsedLoginMethod | undefined => {
  try {
    const storedValue = getFromStorage(LAST_USED_LOGIN_METHOD_KEY)

    if (isLastUsedLoginMethod(storedValue)) {
      return storedValue
    }
  } catch {
    // Access to storage can fail (e.g. Safari private mode); ignore failures gracefully
  }

  return undefined
}

export const setLastUsedLoginMethod = (method: LastUsedLoginMethod) => {
  try {
    setInStorage(LAST_USED_LOGIN_METHOD_KEY, method)
  } catch {
    // Ignore storage set failures; we still proceed without persistence
  }
}
